import { StyleguideModule } from "ui";
export default StyleguideModule;
